
  import { defineComponent, PropType } from 'vue'
  import CellDuration from '@/shared/components/track/CellDuration.vue'
  import CellArtist from '@/shared/components/track/CellArtist.vue'
  import CellAlbum from '@/shared/components/track/CellAlbum.vue'
  import CellTrackNumber from '@/shared/components/track/CellTrackNumber.vue'
  import CellActions from '@/shared/components/track/CellActions.vue'
  import CellTitle from '@/shared/components/track/CellTitle.vue'
  import CellHomePageUrl from '@/shared/components/track/CellHomePageUrl.vue'
  import BaseTable from '@/shared/components/BaseTable.vue'
  import BaseTableHead from '@/shared/components/BaseTableHead.vue'
  import { Track } from '@/shared/api'

  export default defineComponent({
    components: {
      BaseTableHead,
      BaseTable,
      CellTitle,
      CellActions,
      CellTrackNumber,
      CellAlbum,
      CellArtist,
      CellDuration,
      CellHomePageUrl,
    },
    props: {
      share: { type: Boolean },
      tracks: { type: Array as PropType<Track[]>, required: true },
      noAlbum: { type: Boolean, default: false },
      noArtist: { type: Boolean, default: false },
      noDuration: { type: Boolean, default: false },
      homepageUrl: { type: Boolean, default: false },
    },
    computed: {
      isPlaying(): boolean {
        return this.$store.getters['player/isPlaying']
      },
      playingTrackId(): any {
        return this.$store.getters['player/trackId']
      },
    },
    methods: {
      play(index: number) {
        if (this.tracks[index].id === this.playingTrackId) {
          return this.$store.dispatch('player/playPause')
        }
        return this.$store.dispatch('player/playTrackList', {
          index,
          tracks: this.tracks,
        })
      },
      dragstart(item: any, event: any) {
        if (!item.isStream) {
          event.dataTransfer.setData('application/x-track-id', item.id)
        }
      },
    }
  })
